<template>
    <div style="width:100%;background-color: white">
        <v-layout v-if="!showMember">
            <v-flex xs12 sm12 md12 lg12 xl12>
                <v-tabs background-color="transparent"
                        centered
                        next-icon="mdi-arrow-right-bold-box-outline"
                        prev-icon="mdi-arrow-left-bold-box-outline"
                        show-arrows
                        v-model="activeTab"
                >
                    <v-tabs-slider color="#00ab4d"></v-tabs-slider>
                    <v-tab flat color="#00ab4d" :key="0" @click="refreshTabAll" style="width: 150px">
                        Tường lớp
                    </v-tab>
                    <v-tab flat color="#00ab4d" :key="1" @click="refreshTabMember" style="width: 150px">
                        {{$t('lang.class.member')}}
                    </v-tab>
                    <!--v-tab flat color="#00ab4d" :key="1" @click="refreshTabLecture" style="width: 150px">
                        {{$t('lang.class.lecture')}}
                    </v-tab-->
                    <v-tab flat color="#00ab4d" :key="2" @click="refreshTabExercise" style="width: 150px">
                        {{$t('lang.class.exercise')}}
                    </v-tab>
                    <!--v-tab flat color="#00ab4d" key="reference" @click="refreshTabRef" style="width: 150px">
                        {{$t('lang.class.reference')}}
                    </v-tab-->
                    <v-tab flat color="#00ab4d" :key="3" @click="refreshTabReport"
                           v-if="role==1 || role == 4 || role==2" style="width: 150px">
                        {{$t('lang.class.report')}}
                    </v-tab>
                    <v-tab flat color="#00ab4d" :key="4" style="width: 150px" @click="refreshTabLibrary"
                           v-if="role==1 || role == 4">
                        {{$t('lang.class.library')}}
                    </v-tab>
                    <!--
                                                            <v-tab flat color="#00ab4d" key="event">
                                                                {{$t('lang.class.event')}}
                                                            </v-tab>
                    -->
                    <v-tabs-items :touchless="true">
                        <v-tab-item :key="0">
                            <v-container>
                                <v-layout>
                                    <div class="hotClass">
                                        <div class="class class flex sm12 md12 lg12 xl12 yoprimary"
                                             style="padding-top: 10px;width:100%;">
                                            <v-menu style="float: right;color:white;font-weight: bold"
                                                    v-if="cl.creatorId == user.userId">
                                                <div slot="activator" class="editPost">
                                                    <v-icon style="color:white">more_horiz</v-icon>
                                                </div>
                                                <v-list>
                                                    <v-list-tile
                                                            @click="editClass"
                                                            key="edit"
                                                    >
                                                        <v-list-tile-action>
                                                            <v-icon>edit</v-icon>
                                                        </v-list-tile-action>
                                                        <v-list-tile-content>
                                                            <v-list-tile-title>
                                                                {{$t('lang.common.edit')}}
                                                            </v-list-tile-title>
                                                        </v-list-tile-content>
                                                    </v-list-tile>
                                                    <v-list-tile
                                                            @click="deleteClass"
                                                            key="delete"
                                                    >
                                                        <v-list-tile-action>
                                                            <v-icon>delete</v-icon>
                                                        </v-list-tile-action>
                                                        <v-list-tile-content>
                                                            <v-list-tile-title>{{$t('lang.common.delete')}}
                                                            </v-list-tile-title>
                                                        </v-list-tile-content>
                                                    </v-list-tile>
                                                </v-list>
                                            </v-menu>
                                            <div style="margin-right:10px;border-color:white">
                                                <img :src="getClassAvatar(cl)" width="70px"
                                                     height="70px"
                                                     style="border-radius: 70px;border-style:double; margin:5px"
                                                />
                                            </div>
                                            <div class="classTitle">{{cl.className}}</div>
                                            <div class="classCode">Mã lớp: {{cl.classCode}}</div>
                                            <div class="classCode">Khối lớp: {{cl.classBlockName}} - Môn:
                                                {{cl.disciplineName}}
                                            </div>
                                            <!--div class="clazzInfo">{{cl.numberOfStudent}} {{$t('lang.class.student')}}</div-->
                                            <v-icon class="clazzInfo" color="white" v-for="item in cl.rate">star_border
                                            </v-icon>
                                        </div>
                                    </div>
                                </v-layout>
                                <v-layout style="margin: auto;background-color: white;border-radius: 5px" wrap>
                                    <v-flex xs12 sm12 md4 lg4 xl3>
                                        <div class="group">
                                            <div class="groupHeader">
                                                <!--v-icon color="#00ab4d">accessibility</v-icon-->
                                                {{$t('lang.class.member')}}
                                            </div>
                                            <div class="groupContent">
                                                <div v-if="cl.numberOfStudent == undefined || cl.numberOfStudent == null || cl.numberOfStudent == 0">
                                                    Lớp học hiện tại chưa có thành viên nào
                                                </div>
                                                <div v-else>
                                                    <label v-if="role==1 || role == 4">Lớp học có {{cl.numberOfStudent}}
                                                        học viên</label>
                                                    <label v-else>Bạn có {{cl.numberOfStudent -1 }} bạn học</label>
                                                </div>
                                                <div style="text-align: right">
                                                    <v-btn color="#00ab4d" flat @click="toMemberTab"
                                                           style="font-style: normal">Danh sách lớp
                                                    </v-btn>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="group" v-if="role==1 || role == 4 || role==2">
                                            <div class="groupHeader">
                                                <!--v-icon color="#00ab4d">send</v-icon-->
                                                <label v-if="role==4 || role == 1">Bài tập đã giao</label>
                                                <label v-else-if="role==2">Bài tập chưa làm</label>
                                            </div>
                                            <div class="groupContent">
                                                <exercise-dashboard :class-id="classId" @view="onViewExercise"
                                                                    @exercise_report="onViewExerciseReport"
                                                                    ref="exerciseDashboard"/>
                                                <div style="text-align: right">
                                                    <v-btn color="#00ab4d" flat @click="toExercise">Xem tất cả</v-btn>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="group" v-if="role==1 || role == 4">
                                            <div class="groupHeader">
                                                <!--v-icon color="#00ab4d">bar_chart</v-icon-->
                                                Báo cáo chưa gửi
                                            </div>
                                            <div class="groupContent">
                                                <report-dashboard :class-id="classId" @report="onViewReportDashboard"
                                                                  ref="reportDashboard"/>
                                                <div style="text-align: right">
                                                    <v-btn color="#00ab4d" flat style="text-decoration: #00a650"
                                                           @click="toReport">Xem tất cả
                                                    </v-btn>
                                                </div>
                                            </div>
                                        </div>
                                    </v-flex style>
                                    <v-flex xs12 sm12 md8 lg8 xl9>
                                        <feed :class-id="classId" :object-type="0" @view="onViewExercise"
                                              @exercise_report="onViewExerciseReport" @report="onViewReport"
                                              ref="tabAll"/>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-tab-item>
                        <!--v-tab-item :key="1">
                            <v-layout>
                                <v-flex xs12 sm12 md6 lg6 xl6 style="margin:auto">
                                    <feed :class-id="classId" :object-type="1" ref="tabLecture"/>
                                </v-flex>
                            </v-layout>
                        </v-tab-item-->
                        <v-tab-item :key="1" >
                            <v-container>
                                <invite-page :class-id="classId" :cl="cl" ref="tabMember"/>
                            </v-container>
                        </v-tab-item>

                        <v-tab-item :key="2">
                            <v-container>
                                <exercise :class-id="classId" ref="tabExercise" @report="onViewReportDetail"/>
                            </v-container>
                        </v-tab-item>
                        <!--v-tab-item :key="3">
                            <v-layout>
                                <v-flex xs12 sm12 md6 lg6 xl6 style="margin:auto">
                                    <feed :class-id="classId" :object-type="2" ref="tabRef"/>
                                </v-flex>
                            </v-layout>
                        </v-tab-item-->
                        <v-tab-item :key="3" v-if="role==1 ||  role == 4 || role==2">
                            <v-container>
                                <report-page :class-id="classId" ref="tabReport"/>
                            </v-container>
                        </v-tab-item>
                        <v-tab-item :key="4" v-if="role==1 || role == 4">
                            <v-container>
                                <library :class-id="classId" ref="tabLibrary"/>
                            </v-container>
                        </v-tab-item>
                        <!--v-tab-item key="event"></v-tab-item-->

                    </v-tabs-items>
                </v-tabs>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import {message} from '../../services';
    import axios from "axios";
    import ClazzCreate from "../class/createClass";
    import TeacherInfo from "../class/teacherProfile";
    import InvitePage from "./invitePage";
    import Feed from "./feed";
    import Exercise from "./exercise";
    import ReportPage from "./reportPage";
    import Library from "./library";
    import ExerciseDashboard from "./exerciseDashboard";
    import ReportDashboard from "./reportDashboard";

    export default {
        components: {
            ReportDashboard,
            ExerciseDashboard, Library, ReportPage, Exercise, Feed, TeacherInfo, ClazzCreate, InvitePage
        },
        data() {
            return {
                activeTab: "all",
                role: null,
                classId: null,
                cl: {},
                teacher: {},
                showMember: false,
                acceptDelete: true,
                fields: [
                    {
                        value: "index",
                        text: this.$t("lang.common.index"),
                        width: "5%",
                        sortable: false,
                        headerStyle: "text-align:center"
                    },
                    {
                        value: 'name',
                        text: this.$t('lang.user.fullName'),
                        width: "10%",
                        sortable: false,
                        headerStyle: "text-align:left"
                    },
                    {
                        value: 'action',
                        text: this.$t("lang.common.actions"),
                        width: "20%",
                        sortable: false,
                        compound: true,
                        headerAlign: "center",
                        headerStyle: "text-align:center"
                    }
                ],
                lstExercise: [],
                lstReport: []
            }
        },
        watch: {
            $route(to, from) {
                /*
                                //console.log(to);
                                //console.log(from);
                */
                this.classId = to.params.classId;
                ////console.log(this.$route.params.classId);
                axios.post(process.env.VUE_APP_API_URL + "/class/getClass?classId=" + this.classId).then(
                    data => {
                        this.cl = data;
                        this.initInfo();
                    },
                    error => {
                        //console.log(error);
                    }
                );

                //next();
                // react to route changes...
            }

        },
        created() {
            this.initPage();
            window.onscroll = (ev) => {
                ////console.log(this.activeTab);
                ////console.log(window.innerHeight + window.scrollY);
                ////console.log(document.body.offsetHeight);
                if ((window.innerHeight + window.scrollY + 1) >= document.body.offsetHeight) {
                    switch (this.activeTab) {
                        case 0:
                            this.$refs.tabAll.loadMore();
                            break;
                        case 1:
                            //this.$refs.tabMember.loadMore();
                            break;
                        case 2:
                            this.$refs.tabExercise.loadMore();
                            break;
                        case 3:
                            //this.$refs.tabReport.loadMore();
                            break;
                        default:
                            break;
                    }
                }

            };

        },
        beforeDestroy() {
            this.$store.commit("common/setTitle", "");
        },
        methods: {
            getClassAvatar: function (cl) {
                return process.env.VUE_APP_API_URL + "/download/attach/" + cl.avatarId;
            },

            initPage: function () {
                this.user = this.$store.state.auth.user;
                this.role = this.user.role;
                ////console.log(this.user);
                /*
                            if (this.$route.params.role) {
                                this.role = this.$route.params.role;
                            }
                */
                if (this.$route.params.clzz) {
                    this.cl = this.$route.params.clzz;
                    this.classId = this.cl.classId;
                    this.initInfo();
                }
                if (this.$route.params.classId) {
                    this.classId = this.$route.params.classId;
                    ////console.log(this.$route.params.classId);
                    axios.post(process.env.VUE_APP_API_URL + "/class/getClass?classId=" + this.classId).then(
                        data => {
                            this.cl = data;
                            this.$store.commit("common/setTitle", this.cl.className);
                            ////console.log(this.cl);
                            this.initInfo();
                        },
                        error => {
                            ////console.log(error);
                        }
                    );

                }
            },

            checkStudentProfile() {
                //
                // check if student check profile input
                //
                if (this.role == 2) {
                    axios.post(process.env.VUE_APP_API_URL + "/classmember/myMemberProfile?classId=" + this.classId).then(
                        data => {
                            let bUpdateProfile = false;
                            if (data == null || data == "") {
                                bUpdateProfile = true;
                            } else {
                                if (data.markTarget == null || data.examTarget == null) {
                                    bUpdateProfile = true;
                                }
                            }
                            if (bUpdateProfile) {
                                if (confirm("Bạn chưa khai báo thông tin và mục tiêu học tập, bạn có muốn cập nhật?")) {
                                    this.activeTab = 1;
                                    this.$nextTick(
                                        () => {
                                            this.$refs.tabMember.refreshTabMembers();
                                            this.$refs.tabMember.viewMember(data, "student");

                                        }
                                    )
                                }
                            }
                        },
                        error => {
                            //console.log(error);
                        }
                    )
                }
            },

            refreshTabAll: function () {
                ////console.log(this.activeTab);
                this.$refs.tabAll.getPost();
                if (this.$refs.exerciseDashboard != null) {
                    this.$refs.exerciseDashboard.getPost();
                }
                if (this.$refs.reportDashboard != null) {
                    this.$refs.reportDashboard.getReportList();
                }

            },

            refreshTabLecture: function () {
                //console.log(this.activeTab);
                this.$refs.tabLecture.getPost();
            },

            refreshTabMember: function () {
                this.$refs.tabMember.refreshTabMembers();
            },

            refreshTabExercise: function () {
                this.$refs.tabExercise.showList();
            },

            refreshTabReport: function () {
                this.$refs.tabReport.showtab();
            },

            refreshTabLibrary: function () {
                this.$refs.tabLibrary.getPost();
            },

            initInfo: function () {
                axios.post(process.env.VUE_APP_API_URL + "/class/teacherInfo?teacherUserId=" + this.cl.creatorId).then(
                    data => {
                        this.teacher = data;
                        this.teacher.numberOfClass = 3;
                        this.teacher.numberOfStudent = 100;
                        this.teacher.avatarURL = process.env.VUE_APP_API_URL + "/download/attach/" + this.teacher.avatarId;
                        //
                        //
                        //
                        let objectId = this.$route.params.objectId;
                        let objectType = this.$route.params.objectType;
                        let userId = this.$route.params.userId;

                        if (objectId != undefined && objectId != null && objectType != undefined && objectType != null && (objectType == 6 || objectType == 5)) {
                            this.viewExerciseById(objectId, objectType, userId);
                        } else {
                            //
                            // check if student entered profile
                            //
                            this.checkStudentProfile();
                        }

                    },
                    error => {
                        //console.log(error);
                    }
                )
            },

            createClass: function () {
                this.$router.push("/CreateClass");
            },

            viewExerciseById: function (objectId, objectType, userId) {
                ////console.log("---sdfsdf---");
                axios.post(process.env.VUE_APP_API_URL + "/post/getPostByObjectIdAndType?objectId=" + objectId + "&objectType=" + objectType).then(
                    data => {
                        //console.log(data);
                        if (data != null) {
                            if (userId == undefined || userId == null || userId == "") {
                                this.onViewExercise(data);
                            } else {
                                this.activeTab = 2;
                                this.$refs.tabExercise.onView(data, userId);

                            }
                        }
                    },
                );
            },

            toMemberTab() {
                this.activeTab = 1;
                this.refreshTabMember();
            },

            toExercise() {
                this.activeTab = 2;
                this.refreshTabExercise();

            },

            toReport() {
                this.activeTab = 3;
                this.refreshTabReport();
            },

            onViewExercise: function (post) {
                ////console.log("SDFsdfsfsdf");
                this.activeTab = 2;

                this.$refs.tabExercise.onView(post);
            },


            onViewExerciseReport(post) {
                this.activeTab = 2;
                this.$refs.tabExercise.onView(post, null, true);
            },


            onViewReportDashboard(report) {
                this.activeTab = 3;
                this.$refs.tabReport.showReport(report);
            },

            onViewReport: function (post) {
                this.activeTab = 3;
                this.$refs.tabReport.showReportOfPost(post);
            },

            onViewReportDetail: function (report) {
                this.activeTab = 3;
                this.$refs.tabReport.showReportDetail(report);
            },

            editClass: function () {
                this.$router.push("/CreateClass/" + this.classId);
            },

            deleteClass: function () {
                let msg = confirm(this.$t("lang.common.deleteConfirm"))
                if (msg) {
                    axios.post(process.env.VUE_APP_API_URL + "/class/deleteClass?classId=" + this.classId).then(
                        data => {
                            if (data.success) {
                                message.success(this.$t("lang.common.delete_success"));
                                this.$router.go(-1);
                            } else {
                                message.error(this.$t(data.description));
                            }
                        }
                    )
                }
            }
        }
    };
</script>